import type { GlobalFilterItem } from '../types';
import { FilterCompanies } from './companies';
import { FilterExternalClients } from './external-clients';
import { FilterRealEstates } from './real-estates';
import { FilterSegments } from './segments';

export type TabBarStates =
  | 'realestates'
  | 'segments'
  | 'externalclients'
  | 'companies';

/**
 * The tab-selected filter list, mapping each toggle to its GlobalFilter type.
 * Shared between the legacy GlobalFilterModal and the global-search-v2 filter
 * page so the two entry points can't drift.
 */
export function FilterLists({
  selectedTab,
  search,
  filteredItems,
  toggleFilteredItem,
}: {
  selectedTab: TabBarStates;
  search: string;
  filteredItems: GlobalFilterItem[];
  toggleFilteredItem: (item: GlobalFilterItem) => void;
}) {
  switch (selectedTab) {
    case 'externalclients':
      return (
        <FilterExternalClients
          search={search}
          onToggle={(id, displayString) =>
            toggleFilteredItem({
              id,
              type: 'filter_external_clients',
              displayString,
            })
          }
          filteredItems={filteredItems}
        />
      );
    case 'companies':
      return (
        <FilterCompanies
          searchValue={search}
          onToggle={(id, displayString) =>
            toggleFilteredItem({ id, type: 'global_companies', displayString })
          }
          filteredItems={filteredItems}
        />
      );
    case 'segments':
      return (
        <FilterSegments
          search={search}
          onToggle={(id, displayString) =>
            toggleFilteredItem({ id, type: 'global_segments', displayString })
          }
          filteredItems={filteredItems}
        />
      );
    case 'realestates':
      return (
        <FilterRealEstates
          search={search}
          onToggle={(id, displayString) =>
            toggleFilteredItem({
              id,
              type: 'global_realestates',
              displayString,
            })
          }
          filteredItems={filteredItems}
        />
      );
  }
}
